/* eslint-disable react-hooks/exhaustive-deps */
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { Box, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { downloadReport, getJobsData } from "../../features/jobs/jobs";
import { AppType } from "../../utils/helper";

const ViewJobReport = ({ data, appType }) => {
  const dispatch = useDispatch(),
    [currentDownload, setCurrentDownload] = useState(null),
    { modal } = useSelector(getJobsData);

  const isCorporate = AppType.cs === appType;

  const style = {
    color: "var(--C_primary, #D70900)",
    borderBottom: "1px solid red",
  };

  useEffect(() => {
    currentDownload !== null && setCurrentDownload(null);
  }, []);

  return (
    <Box noValidate>
      <>
        <div className="mb-5 flex items-center gap-x-5">
          <p className="text-xs font-bold uppercase whitespace-nowrap">
            <span style={style}>Customers'</span> information
          </p>
          <div className="border border-bottom-2 w-full"></div>
        </div>
        <div className="mb-5">
          <p className="text-[#99A0AE] text-xs font-medium uppercase">
            Account Name
          </p>
          <p className="text-[#0E121B] text-base font-medium">
            {data?.AcctName || <small>Not Available</small>}
          </p>
        </div>
        {/* --------------------------------------------- */}
        {AppType.cav === appType ? (
          <>
            <div className="mb-5">
              <p className="text-[#99A0AE] text-xs font-medium uppercase">
                Customer Address
              </p>
              <p className="text-[#0E121B] text-base font-medium">
                {data?.AcctAddress || <small>Not Available</small>}
              </p>
            </div>

            <div className="mb-5">
              <p className="text-[#99A0AE] text-xs font-medium uppercase">
                Updated Address
              </p>
              <p className="text-[#0E121B] text-base font-medium">
                {data?.UpdatedAcctAddress || <small>Not Available</small>}
              </p>
            </div>

            <div>
              <p className="text-[#99A0AE] text-xs font-medium uppercase">
                Address Description
              </p>
              <p className="text-[#0E121B] text-base font-medium">
                {data?.AddressDescription || <small>Not Available</small>}
              </p>
            </div>

            <br />
            <div className="mb-3 flex items-center gap-x-5">
              <p className="text-xs font-bold uppercase whitespace-nowrap">
                <span style={style}>Vendors'</span> Data
              </p>
              <div className="border border-bottom-2 w-full"></div>
            </div>

            <div className="mb-5">
              <p className="text-[#99A0AE] text-xs font-medium uppercase">
                Vendors' Comment
              </p>
              <p className="text-[#0E121B] text-base font-medium">
                {data?.CommentsVendor || <small>Not Available</small>}
              </p>
            </div>

            {/* <br /> */}
            <div className="mb-5">
              <p className="text-[#99A0AE] text-xs font-medium uppercase">
                Proof of Landmark
              </p>
              <p className="text-[#0E121B] text-base font-medium">
                {data?.AddressVerificationPhotos?.length ? (
                  "Yes"
                ) : (
                  <small>Not provided</small>
                )}
              </p>
            </div>

            {data?.AddressVerificationPhotos?.length > 0 && (
              <>
                <div className="mb-5">
                  <p className="text-[#99A0AE] mb-3 text-xs font-medium uppercase">
                    Landmark images
                  </p>
                  <div className="flex">
                    {data?.AddressVerificationPhotos?.map((url, i) => (
                      <Link
                        to={url?.replaceAll('"', "")?.trim()}
                        alt={"landmark image " + i}
                        target="_blank"
                        rel="noreferrer"
                        download={false}
                      >
                        <img
                          key={i}
                          alt={i}
                          src={url?.replaceAll('"', "")?.trim()}
                          className="mr-4"
                          style={{
                            width: "109px",
                            height: "109px",
                            borderRadius: "5px",
                          }}
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <div className="mb-5">
              <p className="text-[#99A0AE] text-xs font-medium uppercase">
                Customer RC Number
              </p>
              <p className="text-[#0E121B] text-base font-medium">
                {data?.RCNumber || <small>Not Available</small>}
              </p>
            </div>
            <br />
            <div className="mb-3 flex items-center gap-x-5">
              <p className="text-xs font-bold uppercase whitespace-nowrap">
                <span style={style}>Solicitors'</span> Data
              </p>
              <div className="border border-bottom-2 w-full"></div>
            </div>
            <div className="mb-5">
              <p className="text-[#99A0AE] text-xs font-medium uppercase">
                Solicitors' Comment
              </p>
              <p className="text-[#0E121B] text-base font-medium">
                {data?.CommentsVendor || <small>Not Available</small>}
              </p>
            </div>
            <div className="mb-5">
              <p className="text-[#99A0AE] text-xs font-medium uppercase">
                Solicitors' Report
              </p>
              {data?.SolicitorReport ? (
                <button
                  onClick={async () => {
                    try {
                      setCurrentDownload("SolicitorReport");
                      await dispatch(
                        downloadReport(data?.SolicitorReport)
                      ).unwrap();
                      setCurrentDownload(null);
                    } catch (error) {
                      console.error(error);
                      setCurrentDownload(null);
                    }
                  }}
                  className="flex items-end"
                  type="button"
                >
                  <span className="text-[#D70900]">
                    {" "}
                    {modal.loader.download &&
                    currentDownload === "SolicitorReport"
                      ? "Downloading..."
                      : "Download report"}
                  </span>
                  {modal.loader.download &&
                    currentDownload === "SolicitorReport" && (
                      <CircularProgress
                        size="15px"
                        sx={{ color: "#D70900", margin: "5px" }}
                      />
                    )}
                </button>
              ) : (
                <p className="text-[#0E121B] text-base font-medium">
                  <small>Not Available</small>
                </p>
              )}
            </div>
          </>
        )}

        <br />
        <div className="mb-3 flex items-center gap-x-5">
          <p className="text-xs font-bold uppercase whitespace-nowrap">
            <span style={style}>Banks'</span> Rejection Data
          </p>
          <div className="border border-bottom-2 w-full"></div>
        </div>

        <Box>
          <div className="mb-5">
            <p className="text-[#99A0AE] text-xs font-medium uppercase">
              Banks' Comment
            </p>
            <p className="text-[#0E121B] text-base font-medium">
              {data?.VendorJobLedgers?.[0]?.Comment ||
                data?.CorporateVendorJobLedgers?.[0]?.Comment || (
                  <small>Not Available</small>
                )}
            </p>
          </div>

          <div className="mb-5">
            <p className="text-[#99A0AE] text-xs font-medium uppercase">
              Banks' rejection file
            </p>
            {/* CSP REJECTION PART */}
            {isCorporate ? (
              data?.CorporateJobRejections?.[0]?.BankRejectionImages?.[0] ? (
                <button
                  onClick={async () => {
                    try {
                      setCurrentDownload("rejectionReport");
                      await dispatch(
                        downloadReport(
                          data?.CorporateJobRejections?.[0]
                            ?.BankRejectionImages?.[0]
                        )
                      ).unwrap();
                      setCurrentDownload(null);
                    } catch (error) {
                      console.error(error);
                      setCurrentDownload(null);
                    }
                  }}
                  className="mt-2 flex items-end"
                  type="button"
                  disabled={modal.loader.download}
                >
                  <CloudDownloadIcon color="error" />
                  <span className="text-[#D70900] ml-1">
                    {" "}
                    {modal.loader.download &&
                    currentDownload === "rejectionReport"
                      ? "Downloading..."
                      : "Download file"}
                  </span>
                  {modal.loader.download &&
                    currentDownload === "rejectionReport" && (
                      <CircularProgress
                        size="15px"
                        sx={{ color: "#D70900", margin: "5px" }}
                      />
                    )}
                </button>
              ) : (
                <small>Not Available</small>
              )
            ) : // CAV REJECTION PART
            data?.JobRejections?.[0]?.BankRejectionImages?.[0] ? (
              <button
                onClick={async () => {
                  try {
                    setCurrentDownload("rejectionReport");
                    await dispatch(
                      downloadReport(
                        data?.JobRejections?.[0]?.BankRejectionImages?.[0]
                      )
                    ).unwrap();
                    setCurrentDownload(null);
                  } catch (error) {
                    console.error(error);
                    setCurrentDownload(null);
                  }
                }}
                className="mt-2 flex items-end"
                type="button"
                disabled={modal.loader.download}
              >
                <CloudDownloadIcon color="error" />
                <span className="text-[#D70900] ml-1">
                  {" "}
                  {modal.loader.download &&
                  currentDownload === "rejectionReport"
                    ? "Downloading..."
                    : "Download file"}
                </span>
                {modal.loader.download &&
                  currentDownload === "rejectionReport" && (
                    <CircularProgress
                      size="15px"
                      sx={{ color: "#D70900", margin: "5px" }}
                    />
                  )}
              </button>
            ) : (
              <small>Not Available</small>
            )}
          </div>
        </Box>
      </>
    </Box>
  );
};

export default ViewJobReport;
